/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BillingDetails,
    BillingDetailsFromJSON,
    BillingDetailsFromJSONTyped,
    BillingDetailsToJSON,
} from './BillingDetails';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    GeocodeAddress,
    GeocodeAddressFromJSON,
    GeocodeAddressFromJSONTyped,
    GeocodeAddressToJSON,
} from './GeocodeAddress';
import {
    PayoutProvider,
    PayoutProviderFromJSON,
    PayoutProviderFromJSONTyped,
    PayoutProviderToJSON,
} from './PayoutProvider';
import {
    Preferences,
    PreferencesFromJSON,
    PreferencesFromJSONTyped,
    PreferencesToJSON,
} from './Preferences';
import {
    ProgramObjectType,
    ProgramObjectTypeFromJSON,
    ProgramObjectTypeFromJSONTyped,
    ProgramObjectTypeToJSON,
} from './ProgramObjectType';
import {
    ProgramType,
    ProgramTypeFromJSON,
    ProgramTypeFromJSONTyped,
    ProgramTypeToJSON,
} from './ProgramType';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Program
 */
export interface Program {
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    id: string;
    /**
     * 
     * @type {ProgramObjectType}
     * @memberof Program
     */
    object: ProgramObjectType;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    name: string;
    /**
     * 
     * @type {Array<ProgramType>}
     * @memberof Program
     */
    types: Array<ProgramType>;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    picture_url?: string;
    /**
     * 
     * @type {Preferences}
     * @memberof Program
     */
    preferences?: Preferences;
    /**
     * 
     * @type {BillingDetails}
     * @memberof Program
     */
    billing?: BillingDetails;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    phone?: string;
    /**
     * 
     * @type {GeocodeAddress}
     * @memberof Program
     */
    address?: GeocodeAddress;
    /**
     * 
     * @type {boolean}
     * @memberof Program
     */
    featured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Program
     */
    is_verified: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Program
     */
    tags: Array<string>;
    /**
     * 
     * @type {PayoutProvider}
     * @memberof Program
     */
    payment_provider?: PayoutProvider;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    payment_provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    language: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof Program
     */
    default_currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    meta_pixel_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof Program
     */
    created_by?: User;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    updated?: Date;
}

export function ProgramFromJSON(json: any): Program {
    return ProgramFromJSONTyped(json, false);
}

export function ProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): Program {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': ProgramObjectTypeFromJSON(json['object']),
        'name': json['name'],
        'types': ((json['types'] as Array<any>).map(ProgramTypeFromJSON)),
        'picture_url': !exists(json, 'picture_url') ? undefined : json['picture_url'],
        'preferences': !exists(json, 'preferences') ? undefined : PreferencesFromJSON(json['preferences']),
        'billing': !exists(json, 'billing') ? undefined : BillingDetailsFromJSON(json['billing']),
        'website': !exists(json, 'website') ? undefined : json['website'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'address': !exists(json, 'address') ? undefined : GeocodeAddressFromJSON(json['address']),
        'featured': !exists(json, 'featured') ? undefined : json['featured'],
        'is_verified': json['is_verified'],
        'tags': json['tags'],
        'payment_provider': !exists(json, 'payment_provider') ? undefined : PayoutProviderFromJSON(json['payment_provider']),
        'payment_provider_id': !exists(json, 'payment_provider_id') ? undefined : json['payment_provider_id'],
        'language': json['language'],
        'default_currency': CurrencyCodeFromJSON(json['default_currency']),
        'meta_pixel_id': !exists(json, 'meta_pixel_id') ? undefined : json['meta_pixel_id'],
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': !exists(json, 'created_by') ? undefined : UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
    };
}

export function ProgramToJSON(value?: Program | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': ProgramObjectTypeToJSON(value.object),
        'name': value.name,
        'types': ((value.types as Array<any>).map(ProgramTypeToJSON)),
        'picture_url': value.picture_url,
        'preferences': PreferencesToJSON(value.preferences),
        'billing': BillingDetailsToJSON(value.billing),
        'website': value.website,
        'email': value.email,
        'phone': value.phone,
        'address': GeocodeAddressToJSON(value.address),
        'featured': value.featured,
        'is_verified': value.is_verified,
        'tags': value.tags,
        'payment_provider': PayoutProviderToJSON(value.payment_provider),
        'payment_provider_id': value.payment_provider_id,
        'language': value.language,
        'default_currency': CurrencyCodeToJSON(value.default_currency),
        'meta_pixel_id': value.meta_pixel_id,
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
    };
}

